<div class="dasboard-width">
  <div class="row header mar-lft-rgt-0">

    <div class="col-md-2">Report</div>


    <div class="col-md-2">
      <ol class="breadcrumb cust-bread">
        <li class="breadcrumb-item"><a class="pointer" (click)="changeRouting('dashboard')"><i
          class="fa fa-dashboard"></i> Home</a></li>
        <li class="breadcrumb-item active" aria-current="page">Report</li>
      </ol>
    </div>
  </div>
  <div class="row content mr-top-5 mar-lft-rgt-0">
    <div class="card">
      <div class="card-header row">
        <div class="col-md-2">
          <div class="form-group">
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt5" [owlDateTime]="dt5"
                   placeholder="Start Date" [(ngModel)]="dateStart">
            <owl-date-time [pickerType]="'calendar'" #dt5></owl-date-time>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <input class="form-control radius-0 font-13" [owlDateTimeTrigger]="dt6" [owlDateTime]="dt6"
                   placeholder="End Date" [(ngModel)]="dateEnd">
            <owl-date-time [pickerType]="'calendar'" #dt6></owl-date-time>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
                    (change)="onTicketChange($event.target.selectedIndex)">
              <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="categorySelected"
                    >
              <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="statusSelected" multiple
            >
              <option *ngFor="let stat of status" [value]="stat.id">{{stat.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <button class="btn btn-success addButton font-13" (click)="generate()">Generate</button>
        </div>
      </div>
      <div class="loader-img"><img [hidden]="hide_report_loader" class="loading-gif" src="../../../assets/img/loader.gif"></div>
      <div class="card-body card-body-grid1">
        <angular-slickgrid gridId="grid1"
                           [columnDefinitions]="columnDefinitions"
                           [gridOptions]="gridOptions"
                           (onAngularGridCreated)="angularGridReady($event)"
                           gridWidth="3500"
                           (sgOnSelectedRowsChanged)="handleSelectedRowsChanged($event.detail.eventData, $event.detail.args)"
                           [dataset]="dataset">
        </angular-slickgrid>
      </div>
    </div>
  </div>
</div>
<notifier-container></notifier-container>
